import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Clock, Leaf } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function Hero() {
  return <section className="bg-gradient-to-r from-blue-600 to-blue-400 text-white pt-6 pb-10" data-id="element-318">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center" data-id="element-319">
        <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-320">
          <motion.h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight mt-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-321">
            Tu cuerpo no necesita más pastillas. Necesita libertad.
          </motion.h1>
          <motion.p className="text-xl mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-322">
            Cada migraña no solo trae dolor. Trae dependencia, agotamiento… y
            más químicos en tu sistema.
          </motion.p>
          <motion.p className="text-xl mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-323">
            Pero existe otra forma.
          </motion.p>
          <motion.div className="bg-white/20 backdrop-blur-sm p-4 rounded-lg mb-8 flex items-center space-x-3" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-324">
            <Users size={20} className="text-yellow-300 flex-shrink-0" data-id="element-325" />
            <p className="text-sm font-medium" data-id="element-326">
              <span className="font-bold" data-id="element-327">12,476 personas</span> ya dejaron las
              pastillas atrás este año
            </p>
          </motion.div>
          <motion.div className="flex items-center space-x-2 mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-328">
            <Clock size={18} className="text-yellow-300" data-id="element-329" />
            <p className="text-sm font-medium" data-id="element-330">
              Oferta por tiempo limitado:{' '}
              <span className="font-bold" data-id="element-331">50% DESCUENTO</span>
            </p>
          </motion.div>
          <motion.a href="https://shopysv.com/products/pide-tu-gorro-anti-migrana" className="bg-white text-blue-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors inline-flex items-center" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} onClick={() => trackAddToCart()} data-id="element-332">
            <span data-id="element-333">Descubre la alternativa natural</span>
            <motion.div animate={{
            x: [0, 5, 0]
          }} transition={{
            repeat: Infinity,
            duration: 1.5
          }} className="ml-2" data-id="element-334">
              <Leaf size={18} className="text-green-600" data-id="element-335" />
            </motion.div>
          </motion.a>
          <motion.div className="mt-6 flex items-center space-x-2" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.7
        }} data-id="element-336">
            <ShieldCheck size={16} className="text-white" data-id="element-337" />
            <p className="text-sm" data-id="element-338">
              Garantía de devolución de 30 días, sin preguntas
            </p>
          </motion.div>
        </div>
        <motion.div className="md:w-1/2 flex justify-center" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} data-id="element-339">
          <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rhWiMyS3YmrG3MJBU4ruEz/imgi_1_0830_2.gif" alt="Persona usando el gorro terapéutico Alivia para migrañas" className="rounded-lg shadow-2xl max-w-full h-auto" whileHover={{
          scale: 1.03
        }} transition={{
          duration: 0.3
        }} data-id="element-340" />
        </motion.div>
      </div>
    </section>;
}